import { Component, HostListener, Input } from '@angular/core';
import { FieldHistorySearchRequest } from '../../../../models/field-history';
import { TcmModalService } from '../../services/tcm-modal.service';
import { FieldHistorySearchComponent } from '../field-history-search/field-history-search.component';
import { HistoricalEntityEnum, EnumTraslationKeysEnum } from '../../../../models/enums';

@Component({
    selector: 'field-history-button',
    templateUrl: './field-history-button.component.html',
    styleUrls: ['./field-history-button.component.scss'],
    standalone: false
})
export class FieldHistoryButtonComponent {

    @Input() displayNameKey: string;
    @Input() entityId: number;
    @Input() entity: HistoricalEntityEnum;
    @Input() entityField: string;

    @Input() typeOfValue: 'currency' | 'date' | 'datetime' | 'enum';

    @Input() enumTranslationKey: EnumTraslationKeysEnum;

    constructor(private modalService: TcmModalService) {

    }

    @HostListener('click', ['$event'])
    onClick(event: Event) {
        event.stopPropagation();

        const request = {
            id: this.entityId,
            entityName: this.entity,
            fieldName: this.entityField
        } as FieldHistorySearchRequest;

        this.modalService.openComponentInModal(FieldHistorySearchComponent, 'md',
            {
                requestModel: request,
                typeOfValue: this.typeOfValue,
                enumTranslationKey: this.enumTranslationKey,
                titleKey: this.displayNameKey
            }
        );
    }
}
